import C from './constants.js';
import { ACCOUNTS, ROLES } from './permission.js';

const { INITIATIVE, ACTIVITIES, RESULTS } = C;

const defaults = {
    activity: {
        indicatorMetricTargetOn: false,
    },
    result: {},
    assistedInteractions: {
        dropdown: {
            routes: {
                '/initiative-search': {
                    Initiative_Overview_Start_End: [
                        ACCOUNTS.super,
                        ACCOUNTS.funder,
                        ACCOUNTS.grantee,
                    ],
                    Initiative_Overview_Next_Reports_Due: [
                        ACCOUNTS.super,
                        ACCOUNTS.grantee,
                        ACCOUNTS.funder,
                    ],
                    Initiatives_Summary: [
                        ACCOUNTS.super,
                        ACCOUNTS.funder,
                        ACCOUNTS.grantee,
                    ],
                    Initiatives_Summary_Full: [
                        ACCOUNTS.super,
                        ACCOUNTS.funder,
                        ACCOUNTS.grantee,
                    ],
                },
                '/report-search': {
                    Evaluation_Of_Reports: [
                        ACCOUNTS.super,
                        ACCOUNTS.funder,
                        ACCOUNTS.grantee,
                    ],
                    Evaluation_Of_Reports_Activities: [
                        ACCOUNTS.super,
                        ACCOUNTS.funder,
                        ACCOUNTS.grantee,
                    ],
                    Evaluation_Of_Reports_Results: [
                        ACCOUNTS.super,
                        ACCOUNTS.funder,
                        ACCOUNTS.grantee,
                    ],
                },
                '/[initiativeId]/reports/[reportId]': {
                    Report_Summary: [ACCOUNTS.super, ACCOUNTS.funder],
                    Thank_You_Mail: [ACCOUNTS.super, ACCOUNTS.funder],
                    SoMe_Suggestion: [ACCOUNTS.super, ACCOUNTS.grantee],
                    Summary_For_Sharing: [ACCOUNTS.super, ACCOUNTS.grantee],
                    Funder_Summary: [ACCOUNTS.super, ACCOUNTS.funder],
                },
                '/[initiativeId]/reports': {
                    Initiative_Reports_Summary: [
                        ACCOUNTS.super,
                        ACCOUNTS.funder,
                        ACCOUNTS.grantee,
                    ],
                },
                '/[initiativeId]/milestones': {
                    Milestone_Progress_Summary: [
                        ACCOUNTS.super,
                        ACCOUNTS.funder,
                        ACCOUNTS.grantee,
                    ],
                },
            },
        },
        inputs: {
            Summary_Of_Activities: [ACCOUNTS.super, ACCOUNTS.grantee],
            Summary_Of_Challenges_And_Learnings: [
                ACCOUNTS.super,
                ACCOUNTS.grantee,
            ],
        },
    },
};

export default {
    defaults: {
        assistedInteractions: defaults.assistedInteractions,
    },
    [INITIATIVE.BASIC]: {
        name: INITIATIVE.BASIC,
        activities: {
            [ACTIVITIES.INTERVENTION]: defaults.activity,
        },
        results: {
            [RESULTS.CUSTOM_OUTPUT]: defaults.result,
        },
        assistedInteractions: defaults.assistedInteractions,
    },
    [INITIATIVE.BII]: {
        name: INITIATIVE.BII,
        activities: {
            [ACTIVITIES.ENGAGEMENT]: defaults.activity,
            [ACTIVITIES.DEVELOPMENT]: defaults.activity,
            [ACTIVITIES.TEAM_EDUCATION]: defaults.activity,
            [ACTIVITIES.INTERVENTION]: defaults.activity,
        },
        results: {
            [RESULTS.DISSEMINATION]: defaults.result,
            [RESULTS.KNOWLEDGE]: defaults.result,
            [RESULTS.INFLUENCE_ON_POLICY]: defaults.result,
            [RESULTS.AWARD]: defaults.result,
            [RESULTS.PRODUCTS_AND_INVENTIONS]: defaults.result,
            [RESULTS.INVENTION_DISCLOSURE]: defaults.result,
            [RESULTS.PATENTS]: defaults.result,
            [RESULTS.INTELLECTUAL_PROPERTY]: defaults.result,
            [RESULTS.COMPANY]: defaults.result,
        },
        assistedInteractions: defaults.assistedInteractions,
    },
    [INITIATIVE.CULTURE]: {
        name: INITIATIVE.CULTURE,
        activities: {
            [ACTIVITIES.ENGAGEMENT]: defaults.activity,
            [ACTIVITIES.TEACHING]: defaults.activity,
            [ACTIVITIES.DEVELOPMENT]: defaults.activity,
        },
        results: {
            [RESULTS.DISSEMINATION]: defaults.result,
            [RESULTS.INFLUENCE_ON_POLICY]: defaults.result,
            [RESULTS.AWARD]: defaults.result,
        },
        assistedInteractions: defaults.assistedInteractions,
    },
    [INITIATIVE.EDUCATION]: {
        name: INITIATIVE.EDUCATION,
        activities: {
            [ACTIVITIES.ENGAGEMENT]: defaults.activity,
            [ACTIVITIES.EO_TEACHING]: defaults.activity,
        },
        results: {
            [RESULTS.DISSEMINATION]: defaults.result,
            [RESULTS.KNOWLEDGE]: defaults.result,
            [RESULTS.AWARD]: defaults.result,
            [RESULTS.INFLUENCE_ON_POLICY]: defaults.result,
        },
        assistedInteractions: defaults.assistedInteractions,
    },
    [INITIATIVE.EDUCATION_NOT_NNF]: {
        name: INITIATIVE.EDUCATION_NOT_NNF,
        activities: {
            [ACTIVITIES.ENGAGEMENT]: defaults.activity,
            [ACTIVITIES.TEACHING]: defaults.activity,
        },
        results: {
            [RESULTS.DISSEMINATION]: defaults.result,
            [RESULTS.KNOWLEDGE]: defaults.result,
            [RESULTS.INFLUENCE_ON_POLICY]: defaults.result,
            [RESULTS.AWARD]: defaults.result,
        },
        assistedInteractions: defaults.assistedInteractions,
    },
    [INITIATIVE.ENVIRONMENT]: {
        name: INITIATIVE.ENVIRONMENT,
        activities: {
            [ACTIVITIES.ENGAGEMENT]: defaults.activity,
            [ACTIVITIES.TEACHING]: defaults.activity,
            [ACTIVITIES.DEVELOPMENT]: defaults.activity,
            [ACTIVITIES.UPGRADE]: defaults.activity,
            [ACTIVITIES.INTERVENTION]: defaults.activity,
        },
        results: {
            [RESULTS.DISSEMINATION]: defaults.result,
            [RESULTS.KNOWLEDGE]: defaults.result,
            [RESULTS.INFLUENCE_ON_POLICY]: defaults.result,
            [RESULTS.AWARD]: defaults.result,
            [RESULTS.INVENTION_DISCLOSURE]: defaults.result,
            [RESULTS.PATENTS]: defaults.result,
            [RESULTS.INTELLECTUAL_PROPERTY]: defaults.result,
            [RESULTS.COMPANY]: defaults.result,
        },
        assistedInteractions: defaults.assistedInteractions,
    },
    [INITIATIVE.GLOBAL_HEALTH]: {
        name: INITIATIVE.GLOBAL_HEALTH,
        activities: {
            [ACTIVITIES.ENGAGEMENT]: defaults.activity,
            [ACTIVITIES.TEACHING]: defaults.activity,
            [ACTIVITIES.DEVELOPMENT]: defaults.activity,
            [ACTIVITIES.TEAM_EDUCATION]: defaults.activity,
            [ACTIVITIES.SERVICE]: defaults.activity,
        },
        results: {
            [RESULTS.DISSEMINATION]: defaults.result,
            [RESULTS.KNOWLEDGE]: defaults.result,
            [RESULTS.INFLUENCE_ON_POLICY]: defaults.result,
            [RESULTS.AWARD]: defaults.result,
            [RESULTS.PRODUCTS_AND_INVENTIONS]: defaults.result,
        },
        assistedInteractions: defaults.assistedInteractions,
    },
    [INITIATIVE.HUMANITARIAN]: {
        name: INITIATIVE.HUMANITARIAN,
        activities: {
            [ACTIVITIES.ENGAGEMENT]: defaults.activity,
            [ACTIVITIES.TEACHING]: defaults.activity,
            [ACTIVITIES.DEVELOPMENT]: defaults.activity,
            [ACTIVITIES.TEAM_EDUCATION]: defaults.activity,
            [ACTIVITIES.SERVICE]: defaults.activity,
            [ACTIVITIES.UPGRADE]: defaults.activity,
        },
        results: {
            [RESULTS.DISSEMINATION]: defaults.result,
            [RESULTS.KNOWLEDGE]: defaults.result,
            [RESULTS.INFLUENCE_ON_POLICY]: defaults.result,
            [RESULTS.INTELLECTUAL_PROPERTY]: defaults.result,
        },
        assistedInteractions: defaults.assistedInteractions,
    },
    [INITIATIVE.IMPACT_INVESTMENT]: {
        name: INITIATIVE.IMPACT_INVESTMENT,
        activities: {
            [ACTIVITIES.ENGAGEMENT]: defaults.activity,
            [ACTIVITIES.TEACHING]: defaults.activity,
            [ACTIVITIES.DEVELOPMENT]: defaults.activity,
            [ACTIVITIES.SERVICE]: defaults.activity,
            [ACTIVITIES.UPGRADE]: defaults.activity,
            [ACTIVITIES.INTERVENTION]: defaults.activity,
        },
        results: {
            [RESULTS.DISSEMINATION]: defaults.result,
            [RESULTS.KNOWLEDGE]: defaults.result,
            [RESULTS.INFLUENCE_ON_POLICY]: defaults.result,
            [RESULTS.AWARD]: defaults.result,
            [RESULTS.PRODUCTS_AND_INVENTIONS]: defaults.result,
            [RESULTS.INVENTION_DISCLOSURE]: defaults.result,
            [RESULTS.PATENTS]: defaults.result,
            [RESULTS.INTELLECTUAL_PROPERTY]: defaults.result,
            [RESULTS.COMPANY]: defaults.result,
        },
        assistedInteractions: defaults.assistedInteractions,
    },
    [INITIATIVE.INNOVATION]: {
        name: INITIATIVE.INNOVATION,
        activities: {
            [ACTIVITIES.ENGAGEMENT]: defaults.activity,
            [ACTIVITIES.TEACHING]: defaults.activity,
            [ACTIVITIES.DEVELOPMENT]: defaults.activity,
            [ACTIVITIES.SERVICE]: defaults.activity,
            [ACTIVITIES.UPGRADE]: defaults.activity,
            [ACTIVITIES.INTERVENTION]: defaults.activity,
        },
        results: {
            [RESULTS.DISSEMINATION]: defaults.result,
            [RESULTS.KNOWLEDGE]: defaults.result,
            [RESULTS.INFLUENCE_ON_POLICY]: defaults.result,
            [RESULTS.AWARD]: defaults.result,
            [RESULTS.PRODUCTS_AND_INVENTIONS]: defaults.result,
            [RESULTS.INVENTION_DISCLOSURE]: defaults.result,
            [RESULTS.PATENTS]: defaults.result,
            [RESULTS.INTELLECTUAL_PROPERTY]: defaults.result,
            [RESULTS.COMPANY]: defaults.result,
        },
        assistedInteractions: defaults.assistedInteractions,
    },
    [INITIATIVE.INTERMEDIATE]: {
        name: INITIATIVE.INTERMEDIATE,
        activities: {
            [ACTIVITIES.ENGAGEMENT]: defaults.activity,
            [ACTIVITIES.TEACHING]: defaults.activity,
            [ACTIVITIES.DEVELOPMENT]: defaults.activity,
            [ACTIVITIES.SERVICE]: defaults.activity,
            [ACTIVITIES.INTERVENTION]: defaults.activity,
        },
        results: {
            [RESULTS.DISSEMINATION]: defaults.result,
            [RESULTS.KNOWLEDGE]: defaults.result,
            [RESULTS.INFLUENCE_ON_POLICY]: defaults.result,
            [RESULTS.AWARD]: defaults.result,
            [RESULTS.PRODUCTS_AND_INVENTIONS]: defaults.result,
            [RESULTS.CUSTOM_OUTPUT]: defaults.result,
        },
        assistedInteractions: defaults.assistedInteractions,
    },
    [INITIATIVE.PEP]: {
        name: INITIATIVE.PEP,
        activities: {
            [ACTIVITIES.TEACHING]: {
                ...defaults.activity,
                indicatorMetricTargetOn: true,
            },
            [ACTIVITIES.DEVELOPMENT]: {
                ...defaults.activity,
                indicatorMetricTargetOn: true,
            },
            [ACTIVITIES.ENGAGEMENT]: {
                ...defaults.activity,
                indicatorMetricTargetOn: true,
            },
            [ACTIVITIES.SERVICE]: {
                ...defaults.activity,
                indicatorMetricTargetOn: true,
            },
            [ACTIVITIES.UPGRADE]: {
                ...defaults.activity,
                indicatorMetricTargetOn: true,
            },
        },
        results: {
            [RESULTS.DISSEMINATION]: defaults.result,
            [RESULTS.KNOWLEDGE]: defaults.result,
            [RESULTS.INFLUENCE_ON_POLICY]: defaults.result,
        },
        assistedInteractions: defaults.assistedInteractions,
    },
    [INITIATIVE.CBC]: {
        name: INITIATIVE.CBC,
        activities: {
            [ACTIVITIES.CBC_TEACHING]: {
                ...defaults.activity,
                indicatorMetricTargetOn: true,
            },
            [ACTIVITIES.DEVELOPMENT]: {
                ...defaults.activity,
                indicatorMetricTargetOn: true,
            },
            [ACTIVITIES.CBC_ENGAGEMENT]: {
                ...defaults.activity,
                indicatorMetricTargetOn: true,
            },
            [ACTIVITIES.CBC_SERVICE]: {
                ...defaults.activity,
                indicatorMetricTargetOn: true,
            },
            [ACTIVITIES.TEAM_EDUCATION]: {
                ...defaults.activity,
                indicatorMetricTargetOn: true,
            },
            [ACTIVITIES.INTERVENTION]: defaults.activity,
        },
        results: {
            [RESULTS.DISSEMINATION]: defaults.result,
            [RESULTS.KNOWLEDGE]: defaults.result,
            [RESULTS.INFLUENCE_ON_POLICY]: defaults.result,
            [RESULTS.AWARD]: defaults.result,
            [RESULTS.CUSTOM_OUTPUT]: defaults.result,
        },
        assistedInteractions: defaults.assistedInteractions,
    },
    [INITIATIVE.CSLT]: {
        name: INITIATIVE.CSLT,
        activities: {
            [ACTIVITIES.TEACHING]: defaults.activity,
            [ACTIVITIES.DEVELOPMENT]: defaults.activity,
            [ACTIVITIES.ENGAGEMENT]: defaults.activity,
            [ACTIVITIES.SERVICE]: defaults.activity,
            [ACTIVITIES.UPGRADE]: defaults.activity,
        },
        results: {
            [RESULTS.DISSEMINATION]: defaults.result,
            [RESULTS.KNOWLEDGE]: defaults.result,
            [RESULTS.INFLUENCE_ON_POLICY]: defaults.result,
            [RESULTS.AWARD]: defaults.result,
        },
        assistedInteractions: defaults.assistedInteractions,
    },
    [INITIATIVE.RESEARCH_INFRASTRUCTURE]: {
        name: INITIATIVE.RESEARCH_INFRASTRUCTURE,
        activities: {
            [ACTIVITIES.ENGAGEMENT]: defaults.activity,
            [ACTIVITIES.TEACHING]: defaults.activity,
            [ACTIVITIES.TEAM_EDUCATION]: defaults.activity,
            [ACTIVITIES.PHYSICAL]: defaults.activity,
        },
        results: {
            [RESULTS.RESEARCH]: defaults.result,
            [RESULTS.KNOWLEDGE]: defaults.result,
            [RESULTS.INFLUENCE_ON_POLICY]: defaults.result,
            [RESULTS.AWARD]: defaults.result,
            [RESULTS.INVENTION_DISCLOSURE]: defaults.result,
            [RESULTS.PATENTS]: defaults.result,
            [RESULTS.INTELLECTUAL_PROPERTY]: defaults.result,
            [RESULTS.COMPANY]: defaults.result,
        },
        assistedInteractions: defaults.assistedInteractions,
    },
    [INITIATIVE.SCIENCE]: {
        name: INITIATIVE.SCIENCE,
        activities: {
            [ACTIVITIES.ENGAGEMENT]: defaults.activity,
            [ACTIVITIES.TEACHING]: defaults.activity,
            [ACTIVITIES.DEVELOPMENT]: defaults.activity,
        },
        results: {
            [RESULTS.DISSEMINATION]: defaults.result,
            [RESULTS.KNOWLEDGE]: defaults.result,
            [RESULTS.INFLUENCE_ON_POLICY]: defaults.result,
            [RESULTS.AWARD]: defaults.result,
            [RESULTS.PRODUCTS_AND_INVENTIONS]: defaults.result,
            [RESULTS.INVENTION_DISCLOSURE]: defaults.result,
            [RESULTS.PATENTS]: defaults.result,
            [RESULTS.INTELLECTUAL_PROPERTY]: defaults.result,
            [RESULTS.COMPANY]: defaults.result,
        },
        assistedInteractions: defaults.assistedInteractions,
    },
    [INITIATIVE.SOCIAL]: {
        name: INITIATIVE.SOCIAL,
        activities: {
            [ACTIVITIES.ENGAGEMENT]: defaults.activity,
            [ACTIVITIES.TEACHING]: defaults.activity,
            [ACTIVITIES.DEVELOPMENT]: defaults.activity,
            [ACTIVITIES.SERVICE]: defaults.activity,
        },
        results: {
            [RESULTS.DISSEMINATION]: defaults.result,
            [RESULTS.KNOWLEDGE]: defaults.result,
            [RESULTS.INFLUENCE_ON_POLICY]: defaults.result,
            [RESULTS.AWARD]: defaults.result,
        },
        assistedInteractions: defaults.assistedInteractions,
    },

    // Legacy initiatives
    Advanced: {
        name: 'Advanced',
        activities: {
            [ACTIVITIES.ENGAGEMENT]: defaults.activity,
            [ACTIVITIES.TEACHING]: defaults.activity,
            [ACTIVITIES.DEVELOPMENT]: defaults.activity,
            [ACTIVITIES.SERVICE]: defaults.activity,
        },
        results: {
            [RESULTS.DISSEMINATION]: defaults.result,
            [RESULTS.KNOWLEDGE]: defaults.result,
            [RESULTS.INFLUENCE_ON_POLICY]: defaults.result,
            [RESULTS.AWARD]: defaults.result,
        },
        assistedInteractions: defaults.assistedInteractions,
    },
};
